<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import TagMultiSelectComboBox from 'dashboard/components-next/combobox/TagMultiSelectComboBox.vue';

const props = defineProps({
  catalog: { type: Object, default: () => ({}) },
  value: { type: Object, required: true },
});

const emit = defineEmits(['update:value']);
const { t } = useI18n();
const sellers = computed(() => props.value.vendedores_averb || []);
const countOptions = computed(() =>
  Array.from(
    { length: props.catalog.sellers?.length || 0 },
    (_, index) => index + 1
  )
);
const typeOptions = computed(() =>
  (props.catalog.annotation_types || [])
    .filter(type => !['construcao', 'logradouro'].includes(type.id))
    .map(type => ({ value: type.id, label: type.label }))
);

const update = sellersValue =>
  emit('update:value', {
    ...props.value,
    quant_vendedores_averb: sellersValue.length
      ? String(sellersValue.length)
      : '',
    vendedores_averb: sellersValue,
  });
const updateCount = value => {
  const current = sellers.value;
  update(
    Array.from(
      { length: Number(value) },
      (_, index) => current[index] || { id: '', tipo: [] }
    )
  );
};
const updateSeller = (index, field, fieldValue) =>
  update(
    sellers.value.map((seller, sellerIndex) =>
      sellerIndex === index ? { ...seller, [field]: fieldValue } : seller
    )
  );
</script>

<template>
  <section class="grid gap-4">
    <h2 class="text-lg font-semibold text-lais-text">
      {{ t('POST_SALE.TOPICS.ANNOTATION.TITLE') }}
    </h2>
    <label class="grid gap-1 text-sm font-semibold text-lais-text-body">
      {{ t('POST_SALE.TOPICS.ANNOTATION.QUANTITY') }}
      <select
        :value="value.quant_vendedores_averb"
        class="min-h-10 rounded-lais border border-lais-border bg-white px-2 font-normal"
        @change="updateCount($event.target.value)"
      >
        <option value="">{{ t('POST_SALE.FORM.SELECT') }}</option>
        <option v-for="count in countOptions" :key="count" :value="count">
          {{ count }}
        </option>
      </select>
    </label>
    <div
      v-for="(seller, index) in sellers"
      :key="index"
      class="grid gap-4 rounded-lais border border-lais-border-soft p-4 sm:grid-cols-2"
    >
      <label class="grid gap-1 text-sm font-semibold text-lais-text-body">
        {{ t('POST_SALE.TOPICS.ANNOTATION.SELLER') }}
        <select
          :value="seller.id"
          class="min-h-10 rounded-lais border border-lais-border bg-white px-2 font-normal"
          @change="updateSeller(index, 'id', $event.target.value)"
        >
          <option value="">{{ t('POST_SALE.FORM.SELECT') }}</option>
          <option
            v-for="option in catalog.sellers || []"
            :key="option.id"
            :value="option.id"
          >
            {{ option.name }}
          </option>
        </select>
      </label>
      <label class="grid gap-1 text-sm font-semibold text-lais-text-body">
        {{ t('POST_SALE.TOPICS.ANNOTATION.TYPES') }}
        <TagMultiSelectComboBox
          :model-value="[...(seller.tipo || [])]"
          :options="typeOptions"
          :placeholder="t('POST_SALE.FORM.SELECT')"
          @update:model-value="updateSeller(index, 'tipo', $event)"
        />
      </label>
    </div>
  </section>
</template>
